import { memo, useEffect, useState } from "react";
import { Badge, Tab } from "@ir/ui";
import { WorkspacePermissions } from "@/core/permissions";
import { HasAnyPermission } from "@/presentation/workspace";
import { TabType } from "@/store/deduction/drawer";
import { useDeductionDrawer } from "@/presentation/deduction/hooks";
import { useEventBusRejecter, useEventBusSubscriber } from "@/hooks";
import { NotificationEvents } from "@/core/events/notificationEventsMap";

const DeductionConversationTab = () => {
  const { selectedTab, drawerInfo } = useDeductionDrawer();
  const [newMessageCount, setNewMessageCount] = useState(0);
  const rejectSubscriber = useEventBusRejecter();

  /**
   ********************* Reset New Message Count when Remittance Item ID Changes *********************
   */
  useEffect(() => {
    setTimeout(() => {
      setNewMessageCount(0);
    }, 0);
  }, [drawerInfo?.remittanceItemId]);

  /**
   ********************* Reset New Message Count when Remittance Item ID Changes *********************
   */
  useEffect(() => {
    if (TabType.CONVERSATIONS === selectedTab) {
      setTimeout(() => {
        setNewMessageCount(0);
      }, 0);
    }
  }, [selectedTab]);

  /**
   ********************* Handle New Conversation Message Event *********************
   */
  useEventBusSubscriber(NotificationEvents.NEW_CONVERSATION_MESSAGE, payload => {
    if (drawerInfo?.remittanceItemId !== payload.remittanceItemId) {
      rejectSubscriber("This message is not for this conversation");
    }

    if (TabType.CONVERSATIONS === selectedTab) {
      setNewMessageCount(0);
    } else {
      setNewMessageCount(prev => prev + 1);
    }
  });

  /**
   ********************* Render Conversation Tab *********************
   */
  return (
    <HasAnyPermission requiredPermissions={[WorkspacePermissions.CONVERSATIONS_VIEW]}>
      <Tab id={TabType.CONVERSATIONS} aria-label={TabType.CONVERSATIONS} title={TabType.CONVERSATIONS}>
        {TabType.CONVERSATIONS}
        <Badge color="default" count={newMessageCount} />
      </Tab>
    </HasAnyPermission>
  );
};

DeductionConversationTab.displayName = "DeductionConversationTab";
export default memo(DeductionConversationTab);
